import { useEffect, useState } from "react";
import { Button, Icon } from "components/Component";
import { Modal, ModalBody, Spinner } from "reactstrap";
import Swal from "sweetalert2";
import { servicePostLivechatHandoff } from "services/livechat";

const NOTE_MAX = 4000;

// "Pindahkan ke Live Chat": asks a single-use link and hands the ready
// message back to the composer, never sends it on its own.
const ChatModalHandoff = ({ isOpen, setIsOpen, token, chatId, onLink }) => {
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) setNote("");
  }, [isOpen]);

  const submit = async () => {
    setIsLoading(true);
    const response = await servicePostLivechatHandoff(token, chatId, note.trim());
    setIsLoading(false);

    if (!/^20/.test(String(response?.status))) {
      Swal.fire("Gagal", "Link Live Chat belum bisa dibuat, coba lagi.", "error");
      return;
    }

    onLink(response.data.suggestedMessage);
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" toggle={() => setIsOpen(false)} className="modal-dialog-centered">
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <h5 className="title mb-1">Pindahkan ke Live Chat</h5>
        <p className="text-soft mb-3">
          Pesan berisi link Live Chat akan diisi ke kolom chat. Periksa lalu kirim ke pelanggan.
        </p>
        <label className="form-label" htmlFor="handoff-note">
          Catatan internal (opsional)
        </label>
        <textarea
          id="handoff-note"
          className="form-control mb-1"
          rows={4}
          maxLength={NOTE_MAX}
          value={note}
          placeholder="Tidak terlihat oleh pelanggan"
          onChange={(e) => setNote(e.target.value)}
        />
        <div className="text-right text-soft small mb-3">
          {note.length}/{NOTE_MAX}
        </div>
        <Button color="primary" className="btn-block justify-center" disabled={isLoading} onClick={submit}>
          {isLoading ? <Spinner size="sm" /> : "Buat link"}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default ChatModalHandoff;
